import React from 'react'
import {components} from 'react-select';

// Custom dropdown indicator
export const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img
                src={require('assets/images/arrow_forward_ios.png')}
                alt="Dropdown Arrow"
                style={{
                    transform: props.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                    width: '12px',
                    height: '12px',
                    cursor: 'pointer'
                }}
            />
        </components.DropdownIndicator>
    );
};
